import { render, staticRenderFns } from "./paySdkConfig.vue?vue&type=template&id=037d4cb9&"
import script from "./paySdkConfig.vue?vue&type=script&lang=js&"
export * from "./paySdkConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('037d4cb9')) {
      api.createRecord('037d4cb9', component.options)
    } else {
      api.reload('037d4cb9', component.options)
    }
    module.hot.accept("./paySdkConfig.vue?vue&type=template&id=037d4cb9&", function () {
      api.rerender('037d4cb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aymentsdk/paySdkConfig.vue"
export default component.exports